export default "__VITE_ASSET__DIHGtt3A__"